var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sub-content-container',{attrs:{"title":_vm.$t('myInterests.engineering.title')}},[_c('interest',{attrs:{"interests":_vm.completeInterests}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }